export default __webpack_public_path__ + "static/media/Developer_Guidelines_pushorigin.7d6158f6.png";